export default __webpack_public_path__ + "static/media/Minutes of the Annual Shareholder's Meeting 05 March 2021.6ab475ac.pdf";